jQuery(document).ready(function($){
	var $selector = "";

	// $.each($("#aniimated-thumbnials a"), function() {
	// 	var href = $(this).attr('href');
	// 	$(this).attr('data-src',href);
	// 	$(this).attr('data-iframe','true');
	// 	$(this).removeAttr('href');
	// });

	var $lg = $("#aniimated-thumbnials");
	$lg.lightGallery({
		selector: 'a',
	});

	$(".filter-wrapper .filter").on("click", function() {
		$selector = $(this).data("filter");
		$("#aniimated-thumbnials").data('lightGallery').destroy(true);
		$lg.lightGallery({
			selector: $selector,
		});
	});
});
